import { Component, OnInit, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InactivityService } from '../inactivity.service';

type SessionTimeoutDialogData = {
  sessionExpiresAt?: number;
};

@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy{
  counter = 60 * 5;
  displayTime = '';
  private intervalId: any;
  private readonly sessionExpiresAt: number;

  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutDialogComponent>,
    private inactivityService: InactivityService,
    @Inject(MAT_DIALOG_DATA) data: SessionTimeoutDialogData,
  ) {
    this.sessionExpiresAt = data.sessionExpiresAt ?? Date.now() + this.counter * 1000;
  }

  ngOnInit() {
    this.syncDisplayTime();
    this.intervalId = setInterval(() => {
      if (this.syncDisplayTime() === 0) {
        this.onLogout();
      }
    }, 1000);
  }

  updateDisplayTime() {
    const minutes = Math.floor(this.counter / 60);
    const seconds = this.counter % 60;
    this.displayTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  onExtend() {
    this.inactivityService.extendSession();
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  onLogout(): void {
    this.inactivityService.logoutDueToInactivity();
  }

  private syncDisplayTime(): number {
    const remainingSeconds = Math.max(0, Math.ceil((this.sessionExpiresAt - Date.now()) / 1000));
    this.counter = remainingSeconds;
    this.updateDisplayTime();

    return remainingSeconds;
  }
}
